import { render, staticRenderFns } from "./ModalBackofficeCadastroMedicoAssociarCadastro.vue?vue&type=template&id=2664f0d8&scoped=true"
import script from "./ModalBackofficeCadastroMedicoAssociarCadastro.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeCadastroMedicoAssociarCadastro.vue?vue&type=script&lang=ts"
import style0 from "./ModalBackofficeCadastroMedicoAssociarCadastro.vue?vue&type=style&index=0&id=2664f0d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2664f0d8",
  null
  
)

export default component.exports